module.exports = __webpack_public_path__ + "static/media/promo_mama.dd8eb78a.jpg";